<template>
  <div class="login-container">
    <div style="width: 100%; height: 65px; position: fixed; top: 0; background-color: black; z-index: 10;"></div>
    <div class="bg-decoration">
      <div class="bg-circle circle-1"></div>
      <div class="bg-circle circle-2"></div>
    </div>

    <div class="content-wrapper">
      <div class="right-panel">
        <div class="form-container">
          <div class="form-header">
            <h2 class="form-title">找回密码</h2>
            <p class="form-subtitle">通过手机号验证重置您的账户密码</p>
          </div>

          <form @submit.prevent="handleSubmit" class="auth-form">
            <div class="form-group">
              <label for="phone">手机号</label>
              <div class="input-wrapper">
                <input
                  id="phone"
                  v-model="formData.phone"
                  type="tel"
                  placeholder="请输入绑定的手机号"
                  @input="validatePhone()"
                  required
                />
              </div>
              <p class="ys_hongse" v-show="errors.phone">请输入正确的手机号</p>
            </div>

            <div class="form-group">
              <label for="code">验证码</label>
              <div class="input-wrapper">
                <input
                  id="code"
                  v-model="formData.code"
                  type="text"
                  placeholder="请输入收到的验证码"
                  required
                />
                <span class="toggle-password" @click="sendCode" :style="{pointerEvents: canSendCode ? 'auto' : 'none', opacity: canSendCode ? 1 : 0.6}">
                  {{ sendBtnText }}
                </span>
              </div>
            </div>

            <div class="form-group">
              <label for="password">新密码</label>
              <div class="input-wrapper">
                <input
                  id="password"
                  v-model="formData.password"
                  :type="showPassword ? 'text' : 'password'"
                  placeholder="请输入新密码（6-20位，含字母与数字）"
                  @input="validatePassword()"
                  required
                />
                <span class="toggle-password" @click="showPassword = !showPassword">
                  {{ showPassword ? '👁️' : '🙈' }}
                </span>
              </div>
              <p class="ys_hongse" v-show="errors.password">密码需为6-12位的字母与数字</p>
            </div>

            <div class="form-group">
              <label for="confirmPassword">确认新密码</label>
              <div class="input-wrapper">
                <input
                  id="confirmPassword"
                  v-model="formData.confirmPassword"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  placeholder="请再次输入新密码"
                  @input="validateConfirm()"
                  required
                />
                <span class="toggle-password" @click="showConfirmPassword = !showConfirmPassword">
                  {{ showConfirmPassword ? '👁️' : '🙈' }}
                </span>
              </div>
              <p class="ys_hongse" v-show="errors.confirm">两次输入的密码不一致</p>
            </div>

            <button type="submit" class="submit-btn">重置密码</button>

            <div style="text-align:center; margin-top:16px; font-size:13px;">
              <router-link to="/login" style="color:#667eea; text-decoration:none;">返回登录</router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'WangJiMiMa',
  data() {
    return {
      formData: {
        phone: '',
        code: '',
        password: '',
        confirmPassword: ''
      },
      errors: {
        phone: false,
        password: false,
        confirm: false
      },
      showPassword: false,
      showConfirmPassword: false,
      countdown: 0,
      timer: null
    }
  },
  computed: {
    canSendCode() {
      return this.countdown === 0 && !this.errors.phone && this.formData.phone.length > 0
    },
    sendBtnText() {
      return this.countdown > 0 ? `${this.countdown}s` : '获取验证码'
    }
  },
  methods: {
    validatePhone() {
      const phoneReg = /^((13[0-9])|(17[0-1,6-8])|(15[^4,\D])|(18[0-9]))\d{8}$/
      if (this.formData.phone) {
        this.errors.phone = !phoneReg.test(this.formData.phone)
      } else {
        this.errors.phone = true
      }
    },
    validatePassword() {
      const pwd = this.formData.password
      const strong = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/;
      this.errors.password = !strong.test(pwd)
      this.validateConfirm()
    },
    validateConfirm() {
      this.errors.confirm = this.formData.password !== this.formData.confirmPassword
    },
    startCountdown(seconds = 60) {
      this.countdown = seconds
      this.timer && clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1
        } else {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    sendCode() {
      this.validatePhone()
      if (!this.canSendCode) return
      const data = { phone: this.formData.phone }
      axios.post('/api/index/code', data)
        .then(() => {
          this.$message({ message: '验证码已发送，请注意查收', type: 'success' })
          this.startCountdown(60)
        })
        .catch(() => {
          this.$message.error('验证码发送失败，请稍后重试')
        })
    },
    handleSubmit() {
      this.validatePhone()
      this.validatePassword()
      this.validateConfirm()
      if (this.errors.phone || this.errors.password || this.errors.confirm || !this.formData.code) {
        this.$message.error('请完善并修正表单信息后再提交')
        return
      }
      const data = {
        phone: this.formData.phone,
        password: this.formData.password,
        code: this.formData.code
      }
      axios.post('/api/index/forget', data)
        .then((res) => {
          if (res && res.data && (res.data.code === 1 || res.data.success)) {
            this.$message({ message: '密码重置成功，请使用新密码登录', type: 'success' })
            this.$router.push('/login')
          } else {
            this.$message.error(res.data && res.data.msg ? res.data.msg : '重置失败，请稍后重试')
          }
        })
        .catch(() => {
          this.$message.error('重置失败，请检查网络或稍后重试')
        })
    }
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.ys_hongse {
  font-size: 13px;
  color: #fa2807;
}

.login-container {
  width: 100%;
  overflow: hidden;
  background: #ffffff;
  display: flex;
  justify-content: center;
  padding-top: 90px;
  padding-bottom: 50px;
}

.bg-decoration {
  position: absolute;
  inset: 0;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;
}

.bg-circle {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.03) 0%, rgba(102, 126, 234, 0.01) 100%);
}

.circle-1 {
  width: 500px;
  height: 500px;
  top: -200px;
  right: -200px;
}

.circle-2 {
  width: 400px;
  height: 400px;
  bottom: -150px;
  left: -150px;
}

.content-wrapper {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1000px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.right-panel {
  width: 400px;
  background: #ffffff;
  border-radius: 16px;
  padding: 48px 40px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
}

.form-header {
  text-align: center;
  margin-bottom: 36px;

  .form-title {
    font-size: 28px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 8px;
    letter-spacing: -0.3px;
  }

  .form-subtitle {
    font-size: 14px;
    color: #999;
  }
}

.auth-form {
  .form-group {
    margin-bottom: 20px;

    label {
      display: block;
      font-size: 13px;
      font-weight: 500;
      color: #333;
      margin-bottom: 8px;
    }

    .input-wrapper {
      position: relative;
      display: flex;
      align-items: center;

      input {
        width: 100%;
        padding: 12px 16px;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        font-size: 15px;
        color: #1a1a1a;
        background: #fafafa;
        transition: all 0.2s ease;

        &:focus {
          outline: none;
          border-color: #667eea;
          background: #ffffff;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.08);
        }

        &::placeholder {
          color: #aaa;
        }
      }

      .toggle-password {
        position: absolute;
        right: 12px;
        cursor: pointer;
        font-size: 16px;
        user-select: none;
        opacity: 0.9;
        transition: opacity 0.2s ease;

        &:hover {
          opacity: 1;
        }
      }
    }
  }

  .submit-btn {
    width: 100%;
    padding: 14px;
    background: #667eea;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: #5568d3;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

@media (max-width: 600px) {
  .login-container {
    padding: 20px 10px;
  }

  .right-panel {
    padding: 32px 24px;
    border-radius: 12px;
  }

  .form-header .form-title {
    font-size: 24px;
  }
}
</style>


